import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import Reglamentaria from './Reglamentaria';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let desc = '';
let entradaIn = '';
let salidaIn = '';

class InformesJefes extends Component {
    constructor(props){
        super(props);
        this.state = {
            informesSolicitados: [],
            codigosInforme: [],
            busqueda: {
                numeroFuncionario: '',
                codigo: '',
            },

            datoModal: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                motivoRechazo: '',
            },

            consulta: false,
            loading: false,
            errores: null,
            notificaciones: null,
            modalRechazar: false,
            consultaEspecifica: false,
            datoEspecifico: {},
            imagenMostrar: '',
            imagenMostrarModal: false,
            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            horasEntradas: [],
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAceptar = this.manejarAceptar.bind(this);
        this.manejarRechazar = this.manejarRechazar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioRechazo = this.manejarEnvioRechazo.bind(this);
        this.manejarCambioRechazo = this.manejarCambioRechazo.bind(this);
        //this.actList = this.actList.bind(this);
        this.manejarConsultaInforme = this.manejarConsultaInforme.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarModalImagen = this.manejarModalImagen.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
    }


    async componentDidMount(){
        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosInformesFuncionarios.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }

    render(){
        return (
            <>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {sessionStorage.login && (sessionStorage.primeraVez === '0') && sessionStorage.tipoUsuario === '3'
                ?
                    <Container>
                        <h3>Informes</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        {this.state.consulta || this.state.consultaEspecifica
                        ?
                            null
                        :
                            <form onSubmit={this.manejoEnvioConsulta}>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1.5}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>INFORME</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                                <option value=''>INFORMES</option>
                                                {this.state.codigosInforme.map((name) =>
                                                    <option
                                                    key={name.idCodigosInformesFuncionarios}
                                                    value={name.idCodigosInformesFuncionarios}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>NUMERO FUNCIONARIO</Item>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/>
                                        </Grid>
                                        <Grid item xs={1.5}>
                                            <button className="btn btn-outline-primary" type='submit'>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        }
                        <br/>
                        {this.state.consulta
                        ?
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Informe</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell>Número</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell>Hasta</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.informesSolicitados.map((name) => (
                                            <StyledTableRow key={name.idInformes}>
                                                {this.state.codigosInforme.map((name2) => {
                                                    if(name2.idCodigosInformesFuncionarios === name.codigo){
                                                        desc = name2.descripcion;
                                                    }
                                                })}
                                                <StyledTableCell>{desc}</StyledTableCell>
                                                <StyledTableCell>{name.anio}</StyledTableCell>
                                                <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{name.desde}</StyledTableCell>
                                                <StyledTableCell>{name.hasta}</StyledTableCell>
                                                {name.codigo === 3 ? <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarAceptar(name)}>Notificarme</button></StyledTableCell> : <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarAceptar(name)}>Aceptar</button></StyledTableCell>}
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarRechazar(name)}>Rechazar</button></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            null
                        }
                        {this.state.consultaEspecifica
                        ?
                            <Container style={{backgroundColor: '#F2F3F4'}}>
                                <Box sx={{ flexGrow: 1}}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesFuncionarios === this.state.datoEspecifico.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <Grid item xs={4}>
                                        </Grid>
                                        <Grid item xs={4}>
                                            {desc}
                                        </Grid>
                                        <Grid item xs={4}>
                                        </Grid>
                                        {/*Esto va siempre */}
                                        <Grid item xs={2}>
                                        </Grid>
                                        {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Certificado (Imagen)</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 75
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Comprobante (Imagen)</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 10
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Constancia de Domicilio</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 75 || this.state.datoEspecifico.codigo === 10
                                        ?
                                            this.state.datoEspecifico.esPDF
                                            ?
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                                </Grid>
                                            :
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                                </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 21
                                        ?
                                            this.state.datoEspecifico.esPDF
                                            ?
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                                </Grid>
                                            :
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                                </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                        ?
                                            <Grid item xs={1}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Certificado De Parentesco (Imagen)</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11
                                        ?
                                            this.state.datoEspecifico.esPDF
                                            ?
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoActa)}>Descargar</button>
                                                </Grid>
                                            :
                                                <Grid item xs={2}>
                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoActa)}>Ver</button>
                                                </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={1}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Familiar</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 4
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.familiar}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={1}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 4|| this.state.datoEspecifico.codigo === 42
                                        ?
                                            <Grid item xs={2}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75
                                        ?
                                            <Grid item xs={2}>
                                                <Item>{this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.desde}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 61
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.marca1}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 110
                                        ?
                                            <Grid item xs={1}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 10
                                        ?
                                            <Grid item xs={2}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 10
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Nueva Dirección</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 10
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.juzgado}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 56
                                        ?
                                            <Grid item xs={2}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Hasta</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.hasta}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 61
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.marca2}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                        ?
                                        <Grid item xs={1}>

                                        </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 61
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Día</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.desde}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 71 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                        ?    
                                            <Grid item xs={2}>
                                                <Item>Días</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.dias}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                        ?
                                            <Grid item xs={1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Asignatura</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.juzgado}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 20
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Documento</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 20
                                        ?
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Justificativo/Invitación</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Motivo</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.juzgado}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                        ?
                                            <Grid item xs={1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {(this.state.datoEspecifico.codigo === 71) || (this.state.datoEspecifico.codigo === 1) || (this.state.datoEspecifico.codigo === 67) || (this.state.datoEspecifico.codigo === 2) || (this.state.datoEspecifico.codigo === 77) || (this.state.datoEspecifico.codigo === 37) || (this.state.datoEspecifico.codigo === 40) || (this.state.datoEspecifico.codigo === 35) || (this.state.datoEspecifico.codigo === 56) || (this.state.datoEspecifico.codigo === 14) || (this.state.datoEspecifico.codigo === 15) || (this.state.datoEspecifico.codigo === 16) || (this.state.datoEspecifico.codigo === 17) || (this.state.datoEspecifico.codigo === 20)
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.horasEntradas.map((name) => {
                                            if(this.state.datoEspecifico.entrada === name.idEntrada){
                                                entradaIn = name.descripcion;
                                        }})}
                                        {this.state.horasEntradas.map((name) => {
                                            if(this.state.datoEspecifico.salida === name.idEntrada){
                                                salidaIn = name.descripcion;
                                        }})}
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Entrada</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={2}>
                                                {entradaIn}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Salida</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={2}>
                                                {salidaIn}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 71
                                        ?
                                            <Grid item xs={1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                        ?    
                                            <Grid item xs={2}>
                                                <Item>Ejercicio (AÑO)</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.anio}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 2 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                        ?
                                            <Grid item xs={2}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 110
                                        ?    
                                            <Grid item xs={2}>
                                                <Item>Minutos</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.minutos}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35
                                        ?    
                                            <Grid item xs={2}>
                                                <Item>Juzgado</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.juzgado}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                        ?
                                            <Grid item xs={2}>

                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                        ?    
                                            <Grid item xs={2}>
                                                <Item>Tipo Salida</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 77
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.tipo === 0
                                                ?
                                                    'DIA COMPLETO'
                                                :
                                                    this.state.datoEspecifico.tipo === 1
                                                    ?
                                                        'LLEGADA TARDE'
                                                    :
                                                        this.state.datoEspecifico.tipo === 2
                                                        ?
                                                            'SALIDA ANTES DE HORA'
                                                        :
                                                            this.state.datoEspecifico.tipo === 3
                                                            ?
                                                                'SALIDA ENTRE HORARIO'
                                                            :
                                                                null
                                                }
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 37
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.tipo === 1
                                                ?
                                                    'DIA COMPLETO'
                                                :
                                                    this.state.datoEspecifico.tipo === 2
                                                    ?
                                                        'LLEGADA TARDE'
                                                    :
                                                        this.state.datoEspecifico.tipo === 3
                                                        ?
                                                            'SALIDA ANTES DE HORA'
                                                        :
                                                            this.state.datoEspecifico.tipo === 4
                                                            ?
                                                                'SALIDA ENTRE HORARIO'
                                                            :
                                                                null
                                                }
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60
                                        ?  
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.tipo === 1
                                                ?
                                                    'DIA COMPLETO'
                                                :
                                                    this.state.datoEspecifico.tipo === 2
                                                    ?
                                                        'LLEGADA TARDE'
                                                    :
                                                        this.state.datoEspecifico.tipo === 4
                                                        ?
                                                            'SALIDA ANTES DE HORA'
                                                        :
                                                            this.state.datoEspecifico.tipo === 3
                                                            ?
                                                                'SALIDA ENTRE HORARIO'
                                                            :
                                                                null
                                                }
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                        ?  
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?    
                                            <Grid item xs={2.1}>
                                                <Item>Entrada</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?    
                                            <Grid item xs={2.1}>
                                                <Item>Salilda</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?    
                                            <Grid item xs={2.1}>
                                                <Item>Entrada</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 109
                                        ?
                                            <Grid item xs={2.1}>
                                                <Item>Concepto</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 109
                                        ?
                                            <Grid item xs={2.1}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?    
                                            <Grid item xs={2.1}>
                                                <Item>Salilda</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106
                                        ?  
                                            <Grid item xs={2}>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                        ?  
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 110
                                        ?
                                            <Grid item xs={2}>
                                                <Item>Día</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 110
                                        ?
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.desde}
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datoEspecifico.codigo === 110
                                        ?
                                            <Grid item xs={1}>

                                            </Grid>
                                        :
                                            null
                                        }
                                    </Grid>
                                    {this.state.datoEspecifico.codigo === 74
                                    ?
                                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                            <Table sx={{minWidth: 700}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Lunes</StyledTableCell>
                                                        <StyledTableCell>Martes</StyledTableCell>
                                                        <StyledTableCell>Miercoles</StyledTableCell>
                                                        <StyledTableCell>Jueves</StyledTableCell>
                                                        <StyledTableCell>Viernes</StyledTableCell>
                                                        <StyledTableCell>Sábado</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <StyledTableRow>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaLunes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaMartes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaMiercoles === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaJueves === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaViernes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.entradaSabado === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaLunes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaMartes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaMiercoles === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaJueves === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaViernes === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecifico.salidaSabado === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        <StyledTableCell></StyledTableCell>
                                                        <StyledTableCell></StyledTableCell>
                                                        <StyledTableCell>Desde</StyledTableCell>
                                                        <StyledTableCell>{this.state.datoEspecifico.desde}</StyledTableCell>
                                                        <StyledTableCell></StyledTableCell>
                                                        <StyledTableCell></StyledTableCell>
                                                    </StyledTableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 110
                                    ?
                                        <br/>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='comentarios' value={this.state.datoEspecifico.comentarios} disabled/> : null}
                                </Box>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                            </Container>
                        :
                            null
                        }
                        {this.state.imagenMostrarModal
                        ?
                            <Modal open={this.state.imagenMostrarModal}>
                                <Box sx={styleModal} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                        <Grid item xs={5}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>
                        :
                            null
                        }
                        {this.state.consulta
                        ?
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                        :
                            null
                        }
                    </Container>
                :
                    sessionStorage.primeraVez === '1'
                    ?
                        <Redirect to='/primera-vez'/>
                    :
                        <Redirect to='/login'/>
                }
                {sessionStorage.login
                ?
                    <Modal open={this.state.modalRechazar}>
                        <form className='formulario1'>
                            <Box sx={styleModal} >
                                <h3 style={{textAlign:'center'}}>Rechazar Informe</h3>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={6}>
                                        <Item>Número de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Item>{this.state.datoModal.numeroFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Item>Nombre de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Item>{this.state.datoModal.nombreFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Item>Motivo del Rechazo</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='motivoRechazo' type='text' onChange={this.manejarCambioRechazo}></input></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioRechazo}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                :
                    <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            informesSolicitados: [],
            consulta: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, this.state.busqueda, sessionStorage.numeroFuncionarioAsociado]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_informesSolicitados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        this.setState({
            loading: false,
        })
        if(datosInfoSol.length !== 0){
            this.setState({
                informesSolicitados: datosInfoSol,
                consulta: true,
            });
        }else{
            this.setState({
                errores: 'No hay datos para la consulta realizada!',
            })
        }
    }

    async manejarAceptar(dato){
        //Si lo acepta le cambio el estado al informe para que pase a RRHH
        const cargaUtil = JSON.stringify([dato, sessionStorage.numeroFuncionarioAsociado]);

        const res = await fetch(`${Constantes.RUTA_API}/actualizar_informeJefe.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await res.json()
        if(exito){
            //this.actList();
            this.setState(prevState => ({
                informesSolicitados: prevState.informesSolicitados.filter(item => item.idInformes !== dato.idInformes)
            }));
            this.setState({
                notificaciones: 'El informe fue actualizado correctamente!',
                modalRechazar: false,
            })
        }
    }

    manejarRechazar(dato){
        //Si lo rechazo le cambio el estado para que le aparezca al funcionario indicando el motivo
        this.setState({
            modalRechazar: true,
            datoModal: dato,
        })
    }

    cerrarModal(e){
        e.preventDefault();
        //this.obtenerCal();
        this.setState({
            modalRechazar: false,
        });
    }

    /*async actList(e){
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, this.state.busqueda, sessionStorage.numeroFuncionarioAsociado]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_informesSolicitados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        if(datosInfoSol){
            this.setState({
                informesSolicitados: datosInfoSol,
                consulta: true,
            });
        }
    }*/

    async manejarEnvioRechazo(e){
        e.preventDefault();
        if(this.state.datoModal.motivoRechazo === ''){
            this.setState({
                errores: 'Debe ingresar el motivo del rechazo',
                modalRechazar: false,
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.numeroFuncionarioAsociado]);

            const res = await fetch(`${Constantes.RUTA_API}/actualizar_informeJefe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                //this.actList();
                this.setState(prevState => ({
                    informesSolicitados: prevState.informesSolicitados.filter(item => item.idInformes !== this.state.datoModal.idInformes)
                }));
                this.setState({
                    notificaciones: 'El informe fue actualizado correctamente!',
                    modalRechazar: false,
                })
            }
        }
    }

    manejarCambioRechazo(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.datoModal;

            movEditarActualizado[clave] = valor;
            return {
                datoModal: movEditarActualizado,
            }
        })
    }

    manejarConsultaInforme(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            datoEspecifico: dato,
            consulta: false,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            datoEspecifico: {},
            consulta: true,
        })
    }

    manejarModalImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: '',
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            datoModal: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                motivoRechazo: '',
            },

            busqueda: {
                numeroFuncionario: '',
                codigo: '',
            },
            consulta: false,
        })
    }
}

export default InformesJefes